import React, { FC, ReactElement } from 'react';
import styled from 'styled-components';
import HybridLink from 'Client/components/Generic/Links/HybridLink';
import useLoginAndRegisterOverlayWithTracking from 'Client/hooks/useLoginAndRegisterOverlayWithTracking';

const StyledWrapper = styled.div`
    display: flex;
    max-width: 300px;
    margin: 0 auto 10px;
    justify-content: flex-end;
`;

const StyledAnchor = styled(HybridLink)`
    color: ${({ theme }) => theme.colors.turquoise100};
    font-size: 0.9em;
`;

export interface ForgotPasswordLinkProps {
    linkText: string;
    href: string;
}

const ForgotPasswordLink: FC<ForgotPasswordLinkProps> = ({ href, linkText }): ReactElement => {
    const { trackLoginAction } = useLoginAndRegisterOverlayWithTracking();

    return (
        <StyledWrapper>
            <StyledAnchor to={href} onClick={() => trackLoginAction('Password forgotten')}>
                {linkText}
            </StyledAnchor>
        </StyledWrapper>
    );
};

export default ForgotPasswordLink;
